<template>
	<div class="info-cls">
		<div class="type-cls">
			<span>分类</span>
			<el-breadcrumb separator="/">
				<el-breadcrumb-item v-for="(item, index) in currentNodeNameList" :key="index">{{item.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="input-cls">
			<span>标题</span>
			<el-input v-model="qaForm.q" size="small" placeholder="请输入标题..." maxlength="20" show-word-limit clearable></el-input>
		</div>
		<div class="category-cls">
			<span>知识类型</span>
			<el-radio-group v-model="qaForm.type">
				<el-radio label="1">普通知识</el-radio>
				<el-radio label="2">流程引导</el-radio>
			</el-radio-group>
		</div>
		<div class="content-cls">
			<span>内容</span>
			<div class="welfare">
				<quill-editor 
					v-model="qaForm.a" 
					ref="myQuillEditor" 
					:options="editorOption"
					@change="onEditorChange($event)">
				</quill-editor>
				<div class="count">{{TiLength}}/4000</div>
			</div>
		</div>
		<div class="btns-cls">
			<el-button @click.stop="update" size="mini" type="primary">提 交</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'KnowledgeInfo',
	props: ['qaDetail', 'currentNodeNameList'],
	data() {
		const toolOptions = [
			['bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block', 'formula', 'clean'],
			[{ 'align': [] }],
			[{ 'header': 1 }, { 'header': 2 }],
			[{ 'list': 'ordered'}, { 'list': 'bullet' }],
			[{ 'script': 'sub'}, { 'script': 'super' }],
			[{ 'indent': '-1'}, { 'indent': '+1' }],
			[{ 'direction': 'rtl' }],
			[{ 'font': [] }],
			[{ 'size': ['small', false, 'large', 'huge'] }],
			[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
			[{ 'color': [] }, { 'background': [] }]
        ];
		return {
			TiLength: 0,
			qaForm: {
				q: '',
				a: '',
				ashort: '',
				type: '1'
			},
			editorOption: {
                modules:{
                    imageResize: { 
                        displayStyles: {
                            backgroundColor: 'black',
                            border: 'none',
                            color: 'white'
                        },
                        modules: [ 'Resize', 'DisplaySize', 'Toolbar' ]
                    },
                    toolbar: {
                        container: toolOptions
                    }
                }
            },
			addImgRange: ''
		}
	},
	mounted(){
		//数据初始化
		this.TiLength =this.$refs.myQuillEditor.quill.getLength() - 1
	},
	created() {
		this.qaForm = Object.assign(this.qaForm, this.qaDetail);
	},
	methods: {
		onEditorChange(event) {
			event.quill.deleteText(4000,1);
			if(this.qaForm.a===0){
				this.TiLength = 0
			}
			else{
				this.TiLength = event.quill.getLength()-1
			}
		},
		update() {
			if(!this.qaForm.q) {
				this.$message.error('标题不能为空');
				return;
			}
			if(!this.qaForm.a) {
				this.$message.error('内容不能为空');
				return;
			}
			this.$api.apiPostKnowledgeQaUpdate({
				projectId: this.qaForm.projectId,
				id: this.qaForm.id,
				q: this.qaForm.q,
				a: this.qaForm.a,
				ashort: this.$refs.myQuillEditor.quill.getText().substring(0,200),
				type: this.qaForm.type
			}).then(Response => {
				this.$message.success('修改成功');
				this.$emit('MinimizeWindow');
			});
		}
	}
}
</script>

<style lang="scss" scoped>
.info-cls {
	width: 100%;
	padding: 20px;
	box-sizing: border-box;

	& > .type-cls {
		width: 100%;
		height: 20px;
		line-height: 20px;
		margin-bottom: 24px;

		& > span:nth-of-type(1) {
			font-size: 14px;
			font-weight: 400;
			color: #838A9D;
			line-height: 20px;
			margin-right: 18px;
		}

		& .el-breadcrumb {
			display: inline-block;
			line-height: 20px;
			vertical-align: top;
		}
	}

	& > .input-cls {
		width: 100%;
		height: 32px;
		line-height: 32px;
		margin-bottom: 24px;

		& > span:nth-of-type(1) {
			font-size: 14px;
			font-weight: 400;
			color: #838A9D;
			line-height: 20px;
			margin-right: 18px;
		}

		& .el-input {
			width: 300px;
			vertical-align: top;
		}
	}

	& > .category-cls {
		width: 100%;
		height: 20px;
		line-height: 20px;
		margin-bottom: 24px;

		& > span:nth-of-type(1) {
			font-size: 14px;
			font-weight: 400;
			color: #838A9D;
			line-height: 20px;
			margin-right: 18px;
		}

		& .el-radio-group {
			vertical-align: top;
			line-height: 20px;
			margin-top: 3px;
		}
	}

	& > .content-cls {
		width: 100%;
		height: 400px;
		margin-bottom: 24px;

		& > span:nth-of-type(1) {
			font-size: 14px;
			font-weight: 400;
			color: #838A9D;
			line-height: 20px;
			margin-bottom: 8px;
			display: block;
		}

		& > .welfare {
			width: 100%;
			height: calc(100% - 28px);
			border-radius: 4px;
			border: 1px solid #D8D8D8;
			overflow: hidden;

			::v-deep .ql-toolbar {
				border: none;
				background: #f2f2f2;
				border-bottom: solid 1px #D8D8D8;
			}

			::v-deep .ql-container {
				border: none;
				height: 280px !important;
				overflow: auto;
			}

			& > .count {
				margin-top: 8px;
				color: #909399;
				background: #fff;
				font-size: 12px;
				text-align: right;
				padding-right: 8px;
				box-sizing: border-box;
			}
		}
	}

	& > .btns-cls {
		width: 100%;
		height: 28px;
		text-align: center;
	}

}
</style>